import { render } from "./RanksView.vue?vue&type=template&id=236b095b&scoped=true"
import script from "./RanksView.vue?vue&type=script&lang=js"
export * from "./RanksView.vue?vue&type=script&lang=js"

import "./RanksView.vue?vue&type=style&index=0&id=236b095b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236b095b"]])

export default __exports__